export const GET_BIG_SCREEN_DEEP_LINK = 'GET_BIG_SCREEN_DEEP_LINK';
export const GET_BIG_SCREEN_DEEP_LINK_REQUEST = 'GET_BIG_SCREEN_DEEP_LINK_REQUEST';
export const GET_BIG_SCREEN_DEEP_LINK_SUCCESS = 'GET_BIG_SCREEN_DEEP_LINK_SUCCESS';
export const SET_SOCKET_MESSAGE = 'SET_SOCKET_MESSAGE';
